import React, { Component } from 'react';
import ReactAlert from 'react-s-alert';
import Request from '../Request';

class BotaoImprimir extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formato: 'pdf'
      , desabilitarBotao: false
    };
    this.setFormatoPdf = this.setFormatoPdf.bind(this);
    this.setFormatoExcel = this.setFormatoExcel.bind(this);
    this.setFormatoHtml = this.setFormatoHtml.bind(this);
    this.callbackImpressao = this.callbackImpressao.bind(this);
    this.imprimirRelatorioClick = this.imprimirRelatorioClick.bind(this);
  }

  imprimirRelatorioClick() {
    this.renderToast();
    this.setState({ desabilitarBotao: true }, () => {
      let data = this.props.data;
      data.formato = this.state.formato;
      Request.imrpimeRelatorio(this.props.nomeRelatorio, data, this.callbackImpressao, this.callbackErroImpressao);
    });
  }

  callbackImpressao() {
    setTimeout(() => { this.setState({ desabilitarBotao: false }, this.props.callback); }, 2500);
  }

  callbackErroImpressao() {
    this.renderToastErro();
    setTimeout(() => { this.setState({ desabilitarBotao: false }, this.props.errorCallback); }, 2500);
  }

  setFormatoPdf(event) {
    this.setState({ formato: 'pdf' }, event.persist());
  }

  setFormatoExcel(event) {
    this.setState({ formato: 'xls' }, event.persist());
  }

  setFormatoHtml(event) {
    this.setState({ formato: 'html' }, event.persist());
  }

  renderToast() {
    ReactAlert.info('Aguarde para fazer o download do arquivo.', 'Imprimindo...');
  }

  renderToastErro() {
    ReactAlert.error('Ocorreu um erro ao transferir o arquivo, tente novamente mais tarde.', 'Ops! Ocorreu um erro...');
  }

  render() {
    return (
      <div>
        <fieldset disabled={this.state.desabilitarBotao}>
          <div className="btn-group pull-right">
            <button className="btn btn-primary" type="button" onClick={this.imprimirRelatorioClick}><i className="fa fa-print"></i> Imprimir</button>
            <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false" data-placement="top" title="Selecione o formato de saida.">
              <span className="caret"></span>
              <span className="sr-only">Abrir opções</span>
            </button>
            <ul className="dropdown-menu" role="menu">
              <li>
                <a onClick={this.setFormatoPdf} role="button">
                  {this.state.formato === 'pdf' ? <i className="fa fa-check pull-right"></i> : ''}
                  PDF
                </a>
              </li>
              <li>
                <a onClick={this.setFormatoExcel} role="button">
                  {this.state.formato === 'xls' ? <i className="fa fa-check pull-right"></i> : ''}
                  Excel
                </a>
              </li>
              <li>
                <a onClick={this.setFormatoHtml} role="button">
                  {this.state.formato === 'html' ? <i className="fa fa-check pull-right"></i> : ''}
                  HTML
                </a>
              </li>
            </ul>
          </div>
        </fieldset>
      </div>
    );
  }
}

export default BotaoImprimir;


// WEBPACK FOOTER //
// ./src/modulos/componentes/BotaoImprimir.js